import { render, staticRenderFns } from "./GraduationIcon.vue?vue&type=template&id=6978e530&scoped=true&"
import script from "./GraduationIcon.vue?vue&type=script&lang=js&"
export * from "./GraduationIcon.vue?vue&type=script&lang=js&"
import style0 from "./GraduationIcon.vue?vue&type=style&index=0&id=6978e530&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6978e530",
  null
  
)

export default component.exports